import { render, staticRenderFns } from "./path-settings.vue?vue&type=template&id=1dd4ef88&scoped=true&"
import script from "./path-settings.vue?vue&type=script&lang=ts&"
export * from "./path-settings.vue?vue&type=script&lang=ts&"
import style0 from "./path-settings.vue?vue&type=style&index=0&id=1dd4ef88&lang=scss&scoped=true&"
import style1 from "./path-settings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd4ef88",
  null
  
)

export default component.exports